module.exports = __webpack_public_path__ + "img/category-active.0fa6095f.svg";